import React, {useEffect, useState} from "react";
import {Button, Form, Input, Modal, Select, Spin, Tooltip} from "antd";
import {CheckOutlined, CopyOutlined} from '@ant-design/icons';
import Api from "../common/Api";
import variables from "../common/variables";

interface Props {
    setIsModalVisible: (visible: boolean) => void;
    isModalVisible: boolean;
    title: string;
}

interface SelectOptions {
    label: string;
    value: string
}

const SecureLinkModal = ({setIsModalVisible, isModalVisible, title}: Props) => {
    const [form] = Form.useForm();
    const [secureLink, setSecureLink] = useState<string>("");
    const [manufacturers, setManufacturers] = useState<SelectOptions[]>();
    const [loading, setLoading] = useState(false);
    const [copied, setCopied] = useState<boolean>(false)

    const getSecureLink = async () => {
        const {data} = await Api.management.getSecureLink(form.getFieldValue('manufacturer'));
        setSecureLink(`${variables.protocol}://${variables.domain}/sign-up?sig=${data.token}&group=${data.group}`);
    }

    useEffect(() => {
        if (isModalVisible)
            (async () => {
                const manufacturersData = await Api.management.getManufacturers();
                setManufacturers(manufacturersData.data);
                setLoading(false)
            })();
    }, [isModalVisible])

    const handleOk = () => {
        setIsModalVisible(false);
        setSecureLink("")
    };

    const handleCopy = () => {
        const data = [new ClipboardItem({"text/plain": new Blob([secureLink], {type: "text/plain"})})];
        return navigator.clipboard.write(data).then(function () {
            setCopied(true)
            setTimeout(() => {
                setCopied(false)
            }, 1000)
        }, function () {
            setCopied(false)
        });
    }

    return (
      <Modal footer={null} title={title} visible={isModalVisible}
             onCancel={handleOk} destroyOnClose={true}
                   closable={true}>
        <Form
            form={form}
            name="basic"
            labelAlign={"left"}
            style={{width: "100%"}}
            autoComplete="off"
        >
            <Input.Group compact style={{width: "100%", display: "flex", justifyContent: "center"}}>
                <Form.Item name='manufacturer'
                           rules={[{required: true, message: 'Select a manufacturer!',}]}>
                    <Select showSearch
                            style={{width: "100%"}}
                            onChange={getSecureLink}
                            loading={loading}
                            options={manufacturers!}
                            placeholder={"Select a group"}
                            notFoundContent={manufacturers ? <Spin size="small"/> : null}
                            filterOption={(input, option) => (option!.label as unknown as string).includes(input)}
                            filterSort={(optionA, optionB) =>
                                (optionA!.label as unknown as string)
                                    .toLowerCase()
                                    .localeCompare((optionB!.value as unknown as string).toLowerCase())
                            }/>
                </Form.Item>
                <Form.Item style={{width: "100%"}}>
                    <Input.Group compact style={{width: "100%"}}>
                        <Form.Item style={{width: "calc(100% - 28px)"}}>
                            <Input
                                disabled
                                value={secureLink}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Tooltip title={copied ? 'copied!' : 'copy secure link'}>
                                <Button disabled={!secureLink} onClick={handleCopy}
                                        icon={copied ? <CheckOutlined/> : <CopyOutlined/>}/>
                            </Tooltip>
                        </Form.Item>
                    </Input.Group>
                </Form.Item>
            </Input.Group>
        </Form>
    </Modal>)
}

export default SecureLinkModal;
